import axios from "axios";
import { APICLIENT } from "../shared/index";
import { apiendpoints } from "../constants/api-endpoints";
// export const API_BASE_URL = process.env.REACT_APP_API_ENDPOINT;

//******* SIGNUP API *********/
export const signUpService = async (userData) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
    const response = await axioClient.post(apiendpoints.SIGNUP_API, userData);
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//******* LOGIN API *********
export const loginService = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
    const response = await axioClient.post(apiendpoints.LOGIN_API, data);
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//******* LOGOUT API *********
export const LogOutService = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
    const response = await axioClient.post(apiendpoints.SIGNUP_API, data);
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//******* FORGOT API *********
export const ForgotPassword = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
    const response = await axioClient.post(apiendpoints.FORGOT_PASSWORD, data);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

// ********Get_Interest_Api_List ****************
export const getInterestList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.GET_MASTER_SPECIALITY);
    return APICLIENT.handleResponse(response);
  } catch (error) {
    return APICLIENT.handleError(error);
  }
};

// ********Get_Cuisines_Api_List ***********
export const getCuisinesList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.GET_CUISINES_LIST);
    return APICLIENT.handleResponse(response);
  } catch (error) {
    return APICLIENT.handleError(error);
  }
};

//******* ALL LOCATIONS API ****************
export const getAllLocationList = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.ALL_LOCATIONS);
    return APICLIENT.handleResponse(response);
  } catch (error) {
    return APICLIENT.handleError(error);
  }
};

//******* GET_ALL_LOCATION_API *********
export const GetAllLocationsAPI = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
    const response = await axioClient.post(
      apiendpoints.GET_ALL_LOCATIONS,
      data
    );
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//******* GET_EMAIL_EXIST_API *********
export const GetEmailExistAPI = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader());
    const response = await axioClient.post(apiendpoints.IS_EMAIL_EXIST, data);
    return APICLIENT.handleResponse(response);
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};

//******* GET_QUADRANET_PROFILE_API *********/
export const getQuadranetProfile = async () => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.get(apiendpoints.GET_QUADRANET_PROFILE);
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};



//******* UPDATE_TIER_API *********/
export const updateTireAPi = async (data) => {
  try {
    const axioClient = APICLIENT.axioClient(APICLIENT.getHeader(true));
    const response = await axioClient.post(apiendpoints.UPDATE_TIER, data);
    const res = APICLIENT.handleResponse(response);
    return res;
  } catch (err) {
    return APICLIENT.handleError(err);
  }
};
